import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Lightbox } from 'ngx-lightbox';
import { renderMathInDocument } from 'mathlive';
import { Store } from '@ngrx/store';
import { AppStateInterface } from '../../../../../store/state/app.state';
import { hasSubscriptionSelector } from '../../../../../store/selectors/billing.selectors';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent implements OnInit, AfterViewInit, AfterViewChecked {
  @Input() message: any;

  @Input() messages: any;

  @Input() index!: number;

  @Output() replied: EventEmitter<any>;

  @Output() balanceMessageShowed: EventEmitter<any>;

  maxAutoSolStepsDisplay: number = 2;
  private _album: Array<any> = [];
  private hasSubscription: boolean = false;

  constructor(
    private modalService: NgbModal,
    private _lightbox: Lightbox,
    private store: Store<AppStateInterface>,
  ) {
    this.replied = new EventEmitter<any>();
    this.balanceMessageShowed = new EventEmitter<any>();
    this.store.select(hasSubscriptionSelector).subscribe((hasSubscription) => {
      this.hasSubscription = hasSubscription;
    });
  }

  get getRepliedMsg() {
    return this.message.reply_content.id ? this.message.reply_content : {};
  }

  ngAfterViewChecked(): void {
    this.replaceToMathCode();
  }

  ngOnInit(): void {
    if (this.message.type === 'balance' && !this.hasSubscription) {
      this.balanceMessageShowed.emit();
    }
    if (this.isImage(this.message.file?.name)) {
      this._album.push({ src: this.message.file.url });
    }
    if (this.isImage(this.getRepliedMsg.file?.name)) {
      this._album.push({ src: this.getRepliedMsg.file.url });
    }

    this.replaceToMathCode();
  }

  ngAfterViewInit(): void {
    this.replaceToMathCode();
  }

  replaceToMathCode(): void {
    if (
      this.isFormula(this.message) ||
      this.isFormula(this.getRepliedMsg) ||
      this.message.type === 'autosolution' ||
      this.message.type === 'markdown' ||
      this.getRepliedMsg.type === 'autosolution' ||
      this.getRepliedMsg.type === 'markdown'
    ) {
      renderMathInDocument({
        TeX: {
          delimiters: {
            inline: [
              ['$$', '$$'],
              ['$', '$'],
            ],
            display: [['$$', '$$']],
          },
        },
      });
    }
  }

  isImage(filename: string) {
    return /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(filename);
  }

  isFormula(msg: any) {
    return !!((!msg?.file?.name && msg?.file?.url) || msg?.type === 'formula');
  }

  replyMessage(message: any) {
    this.replied.emit(message);
  }

  isNextMessageIsMine(message: any) {
    if (this.messages[this.index + 1]) {
      return this.messages[this.index + 1].author.name === message.author.name;
    } else {
      return false;
    }
  }

  errorHandler(event: any) {
    event.target.src =
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOzYl5mENdSh-2Y_Du5uLJFWWabrVUASKZVCwIbF31naD6ES1GHf2dppUm7BUA5ox52mk&usqp=CAU';
  }

  openLightbox(imgSrc: string) {
    this._lightbox.open(
      this._album,
      this._album.findIndex((el: any) => el.src === imgSrc),
      {
        showImageNumberLabel: true,
        alwaysShowNavOnTouchDevices: true,
        showRotate: true,
        showZoom: true,
        showDownloadButton: true,
      },
    );
  }

  openRepliedAutoSolution(message: any) {
    import('../../modals/autosolution-modal/autosolution-modal-component.module').then(
      ({ AutosolutionModalComponentModule }) => {
        const AutosolutionModalComponent = AutosolutionModalComponentModule.getComponent();
        const modal = this.modalService.open(AutosolutionModalComponent, {
          centered: true,
          scrollable: true,
        });
        modal.componentInstance.message = message;
      },
    );
  }

  billingBtnClick() {
    import('../../../../../components/modals/billing-modal/billing-modal-component.module').then(
      ({ BillingModalComponentModule }) => {
        const BillingModalComponent = BillingModalComponentModule.getComponent();
        this.modalService.open(BillingModalComponent, {
          backdrop: 'static',
          keyboard: false,
        });
      },
    );
  }
}
